export { default as LabelOutlineIcon } from './LabelOutlineIcon';
